import { apiService } from './api.service';
import { AdminDashboard, CompanyDashboard } from 'types/dashboard';

class DashboardService {
  async getCompanyDashboard(): Promise<CompanyDashboard> {
    const response = await apiService.get<CompanyDashboard>(`/dashboard/Company`);
    const data = (response as any)?.data || response;
    if (!data) throw new Error((response as any)?.message || 'Failed to load company dashboard');
    return data as CompanyDashboard;
  }

  async getAdminDashboard(): Promise<AdminDashboard> {
    const response = await apiService.get<AdminDashboard>(`/dashboard/Admin`);
    const data = (response as any)?.data || response;
    if (!data) throw new Error((response as any)?.message || 'Failed to load admin dashboard');
    return data as AdminDashboard;
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;


